import { localStoragePayhelm } from 'modules/utils'
import queryString from 'query-string'

// Validate time string is HH:mm or H:mm (24h)
const isValidTime = (s) => typeof s === 'string' && /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(s.trim())

const queryJson = typeof location !== 'undefined' ? queryString.parse(location.search) : {}
const urlStart = queryJson.startTime
const urlEnd = queryJson.endTime
let startTime = isValidTime(urlStart) ? urlStart.trim() : '00:00'
let endTime = isValidTime(urlEnd) ? urlEnd.trim() : '23:59'

const initialState = {
  startTime,
  endTime,
}

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case 'CHANGE_START_TIME': {
      return {
        ...state,
        startTime: action.payload,
      }
    }
    case 'CHANGE_END_TIME': {
      return {
        ...state,
        endTime: action.payload,
      }
    }
  }
  return state
}